module.exports = __webpack_public_path__ + "img/left-side-menu-master-settings-active.161355cc.svg";